module.exports = __webpack_public_path__ + "static/img/rs.90ac76fd.png";